module.exports = __webpack_public_path__ + "static/media/min.fe8a9db5.svg";